import { render } from "./AtlasToolkitModal.vue?vue&type=template&id=0c9e0aa2&scoped=true"
import script from "./AtlasToolkitModal.vue?vue&type=script&lang=js"
export * from "./AtlasToolkitModal.vue?vue&type=script&lang=js"

import "./AtlasToolkitModal.vue?vue&type=style&index=0&id=0c9e0aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9e0aa2"]])

export default __exports__